<template>
  <div class="sn-f-b-s price">
    <sn-navigator id="WJCX" :initial="perpetual.FUNCTION_ID_WJCX"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s price-region">
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_WJCX) }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 price-blank">
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>查询类型：</div>
            </div>
            <el-select :value="queryType" @change="changeType" placeholder="请选择查询类型">
              <el-option v-for="obj in typeList" :key="obj.itemCode" :label="obj.itemName" :value="obj.itemCode"></el-option>
            </el-select>
          </div>
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>查询名称：</div>
            </div>
            <div>
              <el-input v-model="keyWord" clearable placeholder="请输入查询名称"></el-input>
            </div>
          </div>
          <div class="sn-f-s-c region">
            <el-button type="primary" @click="searchBtn">查询</el-button>
          </div>
        </div>
        <template v-if="!$sn.validate.empty(showList)">
          <!-- <div class="total-title">消费总金额：{{$sn.format.priceFormat(totalCost, 2)}}元</div> -->
          <div class="sn-table">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>名称</th>
                  <th>厂商</th>
                  <th>规格</th>
                  <th>单价（元）</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(obj, index) in showList">
                  <td>{{ index + 1 }}</td>
                  <td>{{obj.medicineName}}</td>
                  <td>{{obj.factory}}</td>
                  <td>{{obj.unit}}</td>
                  <td>{{obj.price === 0 ? '0.00' : $sn.format.priceFormat(obj.price, 2)}}</td>
                  <td class="sn-pointer sn-fc-main" @click="navigateUrl('/query/price/detail', obj, {type: queryType});">查看详情</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
          <div class="sn-f-c-c prompt-message">请输入所要查询信息的首字母拼写进行查询</div>
        </template>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(metaList, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script type="text/javascript">
import * as Tools from '@/common/utils/tools';
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';

export default {
  mixins: [PatientShareMixin],
  data() {
    return {
      typeList: [
        // {
        //   'typeKey': 'price_search_type',
        //   'itemCode': '1',
        //   'itemName': '药品价格查询',
        //   'itemOrder': 0,
        //   'remark': null
        // },
        // {
        //   'typeKey': 'price_search_type',
        //   'itemCode': '0',
        //   'itemName': '非药品价格查询',
        //   'itemOrder': 1,
        //   'remark': null
        // }
      ],
      queryType: null, // 查询类型
      keyWord: '', // 关键字
      metaList: [], // 元数据列表
      pageCount: 1,
      isResult: true,
      exhibitionCreatePatient: false,
      exhibitionBindCard: false
    };
  },
  computed: {
    // 处理费用信息
    showList() {
      let handle = [];
      if (this.metaList.length > 0) handle = this.$sn.format.group(this.metaList, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      return handle;
    }
  },
  watch: {
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || !this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.metaList, this.perpetual.PAGINATION_SIZE)[n])) {
          this.searchBtn();
        }
      },
      immediate: true
    }
  },
  created: function() {
    this.funLoad();
  },
  methods: {
    changeType(val) {
      this.queryType = val;
    },
    async funLoad() {
      document.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_MZBG);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_MZBG);
      this.typeList = await Tools.dict([this.perpetual.DICTIONARY_CODE_PRICE_SEARCH_TYPE]);

      if (this.typeList.length > 0) {
        this.queryType = this.typeList[0].itemCode;
      }
    },
    // 查询门诊费用
    searchBtn() {
      if (this.$sn.validate.empty(this.queryType)) {
        this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['查询类型']));
        return false;
      }
      else if (this.$sn.validate.empty(this.keyWord)) {
        this.getShowToast(this.$sn.format.caption(Messages.SEARCH001, ['所要查询信息']));
        return false;
      }
      this.$sn.assembly.loading(true);
      this.metaList = [];

      const params = {
        url: this.$sn.format.caption(Swagger.getMedicinePriceTable, [this.$sn.utils.getHospitalId()]),
        query: {
          input: this.keyWord,
          type: this.queryType
        },
        header: true
      };
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (result.data) {
              if (result.data.ResultCode === '0') {
                if (result.data.Data && result.data.Data.length > 0) {
                  this.isResult = result.data.Data.length === this.perpetual.PAGINATION_SIZE;
                  this.metaList = result.data.Data;
                }
                else {
                  this.isResult = false;
                }
              }
              else {
                this.getShowToast(result.data.ResultMsg);
              }
            }
          }
          else {
            this.getShowToast(result.msg);
          }
        }
        else {
          this.getShowToast(Messages.C001);
        }
      });
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.metaList, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    },
    // 跳转页面
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '/query/price/detail') {
        this.$sn.utils.setHospitalSessionStorage('price_Info', [item]);
      }
      this.$router[type]({
        path: url,
        query: params
      });
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.price {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &-region {
    overflow: hidden;
    height: 100%;

    .price-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;

      ::v-deep .sn-header-patient {
        .el-date-editor.el-input {
          width: 130px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
      }

      .el-button {
        padding: 10px 20px;
        background-color: $main1;
        border-color: $main1;
      }

      .total-title {
        font-size: 16px;
        margin: 0 20px 20px;
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
